import { ReactNode } from 'react';
import classnames from 'classnames';

interface Props {
  align?: string;
  blur?: boolean;
  children: ReactNode;
  large?: boolean;
}

const CardText = ({
  align = 'start',
  blur = false,
  children,
  large = false,
}: Props) => {
  const className = classnames({
    'mt-0': true,
    'mb-3': true,
    'last:!mb-0': true,
    'only:!mb-0': true,
    'break-words': true,
    'text-left': align === 'start',
    'text-center': align === 'center',
    'text-end': align === 'end',
    'blur-sm': blur,
    'text-lg': large,
  });

  return <p className={className}>{children}</p>;
};

export default CardText;
